

exports.__esModule = true;
exports.$forceLoginExperience = $forceLoginExperience;
exports.$loginEligibility = $loginEligibility;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

var _index2 = require('xo-models/src/auth/index');

var _index3 = require('xo-device-info/dist/index');

function $forceLoginExperience(auth, merchant_country, forcedLogin) {
    var ULParam = _squid.$util.param('ul');

    if (auth.loggedIn() && !auth.stepupAuthRequired && !forcedLogin) {
        return {
            experience: 'apsIntegration',
            reason: 'sessionActive'
        };
    } else if (ULParam === '0' && !_squid.$config.deploy.isLive()) {
        return {
            experience: 'apsIntegration',
            reason: 'ulParamDisabled'
        };
    } else if (ULParam && ULParam.match(/[12]/)) {
        return {
            experience: 'unifiedLogin',
            reason: 'ulParam'
        };
    } else if (ULParam === '3') {
        return {
            experience: 'apsIntegrationRM',
            reason: 'ulParamApsRM'
        };
    } else if (auth.refreshToken()) {
        return {
            experience: 'unifiedLogin',
            reason: 'rememberedUser'
        };
    } else if (_squid.$meta.corp && _squid.$config.ulMeta.allowKMLIForInternalIP && (0, _squid.$feature)('enableOneTouchInternalIP', false, merchant_country)) {
        return {
            experience: 'unifiedLogin',
            reason: 'internalIP'
        };
    }
}

function $loginEligibility(token, forcedLogin) {

    var $scope = {};

    $scope.token = token;

    var routingReason = void 0;

    return (0, _squid.$populate)($scope, {
        auth: _index2.$AuthModel.instance(),
        checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
    }).then(function () {

        var country = $scope.checkoutAppData.merchant.merchant_country;
        var forceLoginExperience = $forceLoginExperience($scope.auth, $scope.checkoutAppData.merchant.merchant_country, forcedLogin);
        var isIneligible = angular.isDefined(forceLoginExperience);

        return (0, _squid.$pxpMatch)(_squid.$config.ulMeta.pxpExpId, {
            'ctx.COUNTRY': country
        }, {
            pxpControl: 'xo_hermesnode_ul_(mobile|web)_control',
            pxpTreatment: 'xo_hermesnode_ul_(mobile|web)_treatment',
            apsIntegration: 'xo_hermesnode_ul_(mobile|web)_aps_treatment',
            apsIntegrationRM: 'xo_hermesnode_ul_(mobile|web)_aps_kmli_treatment'
        }, {
            ineligible: isIneligible
        }).then(function (loginExperience) {

            // To do: do this before calling pxp... otherwise every treatment has ineligible buyers
            if (forceLoginExperience) {
                routingReason = forceLoginExperience.reason;
                return forceLoginExperience.experience;
            }

            var pxpGroup = 'na';

            angular.forEach(loginExperience, function (value, key) {
                if (value) {
                    pxpGroup = key;
                }
            });

            routingReason = pxpGroup;

            switch (pxpGroup) {
                case 'pxpTreatment':
                    return 'unifiedLogin';
                case 'pxpControl':
                    return 'apsIntegration';
                case 'apsIntegration':
                    return 'apsIntegration';
                case 'apsIntegrationRM':
                    return 'apsIntegrationRM';
                default:
                    // For those countries where PXP is not setup, make UL as default
                    if ((0, _squid.$feature)('defaultLoginMethodUL', false, country)) {
                        return 'unifiedLogin';
                    }
                    // Non-UL experience ONLY in case of PXP setup but returned control
                    return 'apsIntegration';
            }
        });
    }).then(function (finalLoginExperience) {

        _logger.$logger.debug(finalLoginExperience === 'unifiedLogin' ? 'ULLOGIN_ELIGIBLE' : 'ULLOGIN_NOT_ELIGIBLE', {
            userGroup: [routingReason],
            routing_reason: routingReason
        });

        var app_int_type = _index3.$DeviceInfo.getAppIntegrationType();

        _logger.$logger.info('checkout_fpti', {
            'from': 'UL_ELG_CHK',
            'to': 'process_ul_elg_chk',
            'routing_reason': routingReason,
            'app_int_type': app_int_type
        });

        return finalLoginExperience;
    });
}

angular.value("$forceLoginExperience", $forceLoginExperience);
angular.value("$loginEligibility", $loginEligibility);
_squid.$util;

_squid.$meta;

_squid.$config;

_squid.$feature;

_squid.$pxpMatch;

_squid.$populate;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index2.$AuthModel;

_index3.$DeviceInfo;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/loginEligibility.js
// module id = ./pages/xo-login/loginEligibility.js
// module chunks = 1